<template>
  <v-layout row wrap>
    <v-row class="vertical ma-0 pa-0" v-if="tasks.length == 0">
      <v-flex xs12 style="text-align: center;">
        <v-icon size="100" style="margin-bottom: 10px;">
          mdi-file-question-outline
        </v-icon>
        <p>
          No tasks found! Create a new task <a style="color: #f0a73a; text-decoration: none;"
                                               href="/work-order/task-manager">here</a>.
        </p>
      </v-flex>
    </v-row>
    <v-flex v-else :class="(selected && selected.id) && `hide-list`" xs12>
      <v-layout row wrap class="task-list">
        <v-flex xs12>
          <v-card class="task-card sort-bar">
            <v-layout row wrap>
              <v-flex xs4 class="text-left pb-0" style="font-weight: 700; padding-top: 16px; padding-right: 0;">
                Tasks <span style="color: #b1b0b0; font-weight: 500;">{{ taskPagination.count }}</span>
              </v-flex>
              <v-flex xs8 class="text-right pr-1" style="display: flex; padding-top: 10px;">
                <div style="flex-grow: 1; float: left;">
                <v-select
                  :items="sortList"
                  solo
                  flat
                  outlined
                  v-model="selectedSortCode"
                ></v-select>
                </div>
                <div class="sort-direction-wrapper">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click='toggleSortDirection'
                      class="text-right"
                      color="accent"
                      small
                      icon
                      v-on="on"
                      height="36"
                      width="36"
                    >
                      <span v-if="isDesc"><v-icon>mdi-sort-descending</v-icon></span>
                      <span v-else><v-icon>mdi-sort-ascending</v-icon></span>
                    </v-btn>
                  </template>
                  <span>Sort Direction</span>
                </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex
          xs12
          v-for="(task, index) in tasks"
          :key="index">
          <v-card
            :ripple="false" v-bind:class="selected && task.id === selected.id ? 'pa-3 task-card card-selected' : setFlaggedCards(task)"
            @click="selectTask(task)">
            <v-layout row wrap>
              <v-flex xs7 class="font-weight-bold">
                WO {{ task.workOrder.workOrderNumber }} - {{ task.taskNumber }}
              </v-flex>
              <v-flex xs5 class="text-right grey-text">{{ task.status }}</v-flex>
            </v-layout>
            <v-layout>
              <div style="padding-left:8px;">
                <div v-if="task.flagged ==='ATTN'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon> </div>
                <div v-if="task.flagged ==='PON'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
                <div v-if="task.flagged ==='BOTH'"> <v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon><v-icon dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
              </div>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 style="line-height: 1.3;" v-if="task.description && task.description.length < 32">{{
                task.description }}
              </v-flex>
              <v-flex xs12 style="line-height: 1.3;" v-else>{{task.description && task.description.substr(0,32)+"..."
                }}
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs10 class="grey-text" style="line-height: 1.3;">{{ task.address }}</v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 class="grey-text" style="height: 22px;">
                <div class="isd-wrapper">
                  {{ task.isd.substr(0, 10) }}
                </div>
              </v-flex>
              <v-flex xs6>
                <div class="edit-btn-wrapper">
                  <v-btn
                    :ripple="false" v-bind:class="selected && task.id === selected.id ? 'pa-3 task-card card-selected' : setFlaggedCards(task)"
                    @click="editTask(task)" style="float: right;" height="32px" width="32px" small icon>
                    <v-icon class="edit-icon">mdi-square-edit-outline</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    sortName: 'isd',
    isDesc: true,
    sortList: [
      { text: 'ISD', value: 'isd' },
      { text: 'Start Date', value: 'start' },
      { text: 'End Date', value: 'end' }
    ]
  }),

  methods: {
    ...mapActions({
      getTask: 'workOrderTask/getTask',
      sortTasks: 'workOrderTask/getTasks',
      clear: 'workOrderTask/clearSort',
      toggleDirection: 'workOrderTask/toggleSortDirection',
      clearDocs: 'document/clearDocumentTasks',
      clearImages: 'image/clearImageTasks',
      clearChangeOrders: 'changeOrder/clearChangeTasks'
    }),
    selectTask (task) {
      this.clearDocs()
      this.clearImages()
      this.clearChangeOrders()

      this.getTask(task.id)
    },
    setFlaggedCards (task) {
      return task.flagged === 'NONE' ? 'pa-3 task-card' : 'pa-3 task-card card-flagged'
    },
    async editTask (task) {
      await this.getTask(task.id)
      this.$router.push('/work-order/task-manager')
    },
    async toggleSortDirection () {
      if (this.isDesc) { this.isDesc = false } else { this.isDesc = true }

      this.search()
    },
    search () {
      var data = {
        sortOrder: this.sortName,
        isDesc: this.isDesc,
        fortask: true
      }
      this.toggleDirection(data)
      let searchReturn = {
        pageIndex: 1
      }
      this.searchObject.searchReturn = searchReturn
      this.sortTasks(this.searchObject)
    },
    clearSort () {
      this.clear(true)
    }
  },
  computed: {
    ...mapGetters({
      tasks: 'workOrderTask/tasks',
      selected: 'workOrderTask/selectedTask',
      taskPagination: 'workOrderTask/taskPagination',
      taskSort: 'workOrderTask/taskSort',
      searchObject: 'workOrderTask/searchObject'
    }),
    selectedSortCode: {
      get () {
        return this.sortName
      },
      async set (value) {
        this.sortName = value
        this.search()
      }
    }
  }
}
</script>

<style>
  .task-list .grey-text {
    color: #b1b0b0;
  }

  .task-list .sort-bar {
    padding: 8px 4px 9px 12px;
  }

  .task-list .sort-bar .v-input {
    font-size: 14px !important;
  }

  .task-list .sort-bar .v-text-field {
    padding: 0 !important;
    margin: 0 !important;
    height: 32px;
  }

  .task-list .sort-bar .v-text-field--outlined .v-input__control .v-input__slot {
    min-height: 36px;
  }

  .sort-direction-wrapper {
    width: 36px;
    height: 36px;
    margin: 0 6px;
    float: left;
  }

  .task-list .card-selected .grey-text {
    color: #ffffff;
  }

  .task-list .card-selected {
    background-color: #f0a73a;
    color: #ffffff;
  }

  .task-list .card-flagged {
    background-color: #ff5b5b !important;
    color: #ffffff;
  }


  .task-list .card-flagged .grey-text {
    background-color: #ff5b5b !important;
    color: #ffffff;
  }

  .task-list .card-selected .edit-icon,
  .task-list .card-flagged .edit-icon {
    color: #ffffff !important;
  }

  .task-list .edit-icon {
    color: #f0a73a !important;
  }

  .task-list {
    height: 100%;
    padding: 8px 0;
  }

  .task-list .task-card:hover {
    cursor: pointer;
    position: relative;
  }

  .task-list .sort-bar {
    cursor: default !important;
  }

  .task-list .isd-wrapper {
    position: absolute;
    bottom: 8px;
    left: 12px;
  }

  .task-list .edit-btn-wrapper {
    position: absolute;
    bottom: 8px;
    right: 6px;
  }

  .vertical {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 70vh;
  }

  @media only screen and (max-width: 959px) {
    .hide-list {
      display: none;
    }
  }

</style>
